import { render, staticRenderFns } from "./PaceOfPlay.vue?vue&type=template&id=44e020f9&scoped=true&"
import script from "./PaceOfPlay.vue?vue&type=script&lang=js&"
export * from "./PaceOfPlay.vue?vue&type=script&lang=js&"
import style0 from "./PaceOfPlay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PaceOfPlay.vue?vue&type=style&index=1&id=44e020f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e020f9",
  null
  
)

export default component.exports